import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75b14150"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import VButton from "@/components/VButton.vue";
import { useAuthentication } from "@/composables/useAuthentication";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { login } = useAuthentication();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      src: require('@/assets/connect.png'),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(login) && _unref(login)(...args)))
    }, null, 8, _hoisted_1)
  ]))
}
}

})